const enum ConsigneFilter {
    None = 0,
    Status = 1,
    State = 2,
}

export default ConsigneFilter;